import A11yScanner from 'umg-ember-backend/components/record-explorer/for/a11y-scanner';

<template>
  <A11yScanner @records={{@model}} @recordType='a11y-scanner' />
</template>
